
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[slug]/collections/[...collectionSlug]",
      function () {
        return require("private-next-pages/[slug]/collections/[...collectionSlug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[slug]/collections/[...collectionSlug]"])
      });
    }
  